import Box from "@material-ui/core/Box";
import React from "react";
import Typography from "@material-ui/core/Typography";
import { useTranslate } from "react-admin";

const Empty = () => {
  const translate = useTranslate();
  return (
    <Box textAlign="center" m={4}>
      <Typography variant="h4" paragraph>
        {translate("resources.research-project-evals.empty_list")}
      </Typography>
    </Box>
  );
};

export default Empty;
